import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=f75f3726&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=f75f3726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f3726",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Stats.vue
// module id = null
// module chunks = 